/**
 * Role helper utilities for checking user roles
 */

export const getUserRole = (): string => {
  return localStorage.getItem('userRole') || 'user';
};

export const isSuperAdmin = (): boolean => {
  return getUserRole() === 'super_admin';
};

export const isAdmin = (): boolean => {
  return getUserRole() === 'admin';
};

export const isAdminOrSuper = (): boolean => {
  const role = getUserRole();
  return role === 'admin' || role === 'super_admin';
};

